module.exports = __webpack_public_path__ + "img/partner15.1a691e69.png";